const CONSUMER_ORIGIN_PATTERN = /^(https?:\/\/(?:develop\.)?classpass\.com)/i;
const STUDIOS_PATH_SUFFIX_PATTERN = /studios\/(.+)$/i;
const MISSING_SLASH_BEFORE_STUDIOS_PATTERN = /\.comstudios\//i;

export const repairVenueAliasUrl = url => {
  if (!url || !MISSING_SLASH_BEFORE_STUDIOS_PATTERN.test(url)) return url;
  return url.replace(MISSING_SLASH_BEFORE_STUDIOS_PATTERN, '.com/studios/');
};

export const getConsumerOrigin = url => {
  if (!url) return null;
  const match = url.match(CONSUMER_ORIGIN_PATTERN);
  return match ? match[1] : null;
};

export const safelyParseUrl = url => {
  if (!url) return null;

  try {
    return new URL(url);
  } catch {
    return null;
  }
};

export const extractStudiosPathSuffix = url => {
  if (!url) return null;
  const match = String(url).match(STUDIOS_PATH_SUFFIX_PATTERN);
  return match ? match[1] : null;
};

export const normalizeVenueAliasUrl = (venueAliasUrl, shareUrlConsumerVenue) => {
  if (!venueAliasUrl) return null;

  const repairedVenueAliasUrl = repairVenueAliasUrl(venueAliasUrl);
  const consumerOrigin = getConsumerOrigin(shareUrlConsumerVenue) || getConsumerOrigin(repairedVenueAliasUrl);
  if (!consumerOrigin) return venueAliasUrl;

  const parsedAlias = safelyParseUrl(repairedVenueAliasUrl);
  if (parsedAlias?.origin === consumerOrigin) {
    return parsedAlias.href;
  }

  const pathSource = parsedAlias
    ? `${parsedAlias.pathname}${parsedAlias.search}${parsedAlias.hash}`
    : repairedVenueAliasUrl;
  const studiosPathSuffix = extractStudiosPathSuffix(pathSource);
  if (!studiosPathSuffix) return venueAliasUrl;

  return `${consumerOrigin}/studios/${studiosPathSuffix}`;
};
